import axios from 'axios';
import { get } from 'lodash';
import React, { Fragment, lazy, Suspense } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import PrivateRoute from '../../components/PrivateRoute';
import { API_HOST, UserContext } from '../../consts';
import * as pages from '../../pages/index';
import queryString from 'query-string';
import withTracker from '../../withTracker';
import HeaderDrawer from './HeaderDrawer/HeaderDrawer';

import GPTForm from '../../pages/open-ai/GPTFormPlan';
import GPTResponse from '../../pages/open-ai/GPTResponse';
import GPTResponseOld from '../../pages/open-ai/GPTResponseOld';
import GPTFormInd from '../../pages/open-ai/GPTFormInd';
import GPTFormGroup from '../../pages/open-ai/GPTFormGroup';
import GPTFormIndPlan from '../../pages/open-ai/GPTFormIndPlan';
import GPTFormInter from '../../pages/open-ai/GPTFormInter';
import ChapterUpload from '../../pages/books/chapterUpload';
import { BookUploadProvider } from '../../pages/books/context';
import PortalEducat from '../../pages/portal/PortalEducat'
import OpenWebUi from '../../pages/open-web-ui/OpenWebUi'

const Itens = lazy(() => import('../../routers/Itens'));
const Relatorios = lazy(() => import('../../routers/Relatorios'));
const Redacoes = lazy(() => import('../../routers/Redacoes'));
const MatrizesReferencia = lazy(() =>
  import('../../routers/MatrizesReferencia')
);
const Analise = lazy(() => import('../../routers/Analise'));
const Testes = lazy(() => import('../../routers/Testes'));
const Avaliacoes = lazy(() => import('../../routers/Avaliacoes'));
const Usuarios = lazy(() => import('../../routers/Usuarios'));
const Recursos = lazy(() => import('../../routers/Recursos'));
const Cruds = lazy(() => import('../../routers/Cruds'));
const FAQ = lazy(() => import('../../routers/Faq'));
const PAE = lazy(() => import('../../routers/pae'));
const Atividades = lazy(() => import('../../routers/Atividades'));

class MainSection extends React.Component {
  constructor(props) {
    super(props);

    const token = localStorage.getItem('token');
    if (token) {
      axios.defaults.headers.common.Authorization = `JWT ${token}`;
    } else {
      delete axios.defaults.headers.common.Authorization;
    }

    axios.interceptors.response.use(null, (error) => {
      const status = get(error, 'response.status');
      if (status === 401) {
        const { history } = props;
        // const message = 'Sessão expirada.';

        localStorage.removeItem('token');
        // toast.error(message);
        history.push('/login');
      } else if (status === 403) {
        const message = get(
          error,
          'response.data.detail',
          'Você não tem permissão para executar essa ação.'
        );
        toast.error(message);
      }

      return Promise.reject(error);
    });
  }

  state = {
    features: [],
    permissions: {},
    menu: [],
    user: {},
    groups: {},
    isLoading: true
  };

  componentDidMount() {
    this.fetchUser().then((user) => {
      const isExamUser =
        user.groups.includes('ALUNO') || user.groups == ['RESPONSAVEL'];

      if (
        !this.props.location.pathname.includes(
          'external-application-middleware'
        ) &&
        isExamUser &&
        !(
          window.location.href.includes('/filter-aluno-disciplina') ||
          window.location.href.includes('/relatorio-meu')
        )
      ) {
        const pathName = `/external-application-middleware?${queryString.stringify(
          { applicationName: 'exams', path: '/', forceLogout: true }
        )}`;
        window.open(pathName, '_self');
      }

      this.setState({ isLoading: false });
      this.fetchPermissions();
      this.fetchMenu();
      this.fetchGroupsProvider();
    });
  }

  componentDidUpdate(prevProps) {
    const prevPath = get(prevProps, 'location.pathname');
    const path = get(this.props, 'location.pathname');
    if (prevPath !== path) {
      window.scrollTo(0, 0);
    }
  }

  get contextProps() {
    const { features, permissions, user, menu, groups } = this.state;

    const hasPermission = (name) => {
      return permissions.__all__ || permissions[name];
    };

    return {
      features,
      permissions,
      user,
      menu,
      hasPermission,
      groups
    };
  }

  get shouldRenderAllMenus() {
    const { permissions } = this.state;
    return get(permissions, '__all__');
  }

  async fetchUser() {
    const response = await axios.get(`${API_HOST}/login/me`);
    this.setState({ user: response.data });

    return response.data;
  }

  async fetchPermissions() {
    const response = await axios.get(`${API_HOST}/login/me/permissions`);
    this.setState({ permissions: response.data });

    return response.data;
  }

  fetchMenu() {
    axios.get(`${API_HOST}/menu/menu`).then((response) => {
      this.setState({ menu: response.data });
    });
  }

  fetchGroupsProvider() {
    if ({ groups: window.localStorage.getItem('payload_permissions') }) {
      this.setState({
        groups: JSON.parse(window.localStorage.getItem('payload_permissions'))
      });
    }
  }
  fetchDeleteGroupsProvider() {
    // if(groups==={}||groups==={''}){
    //   window.localStorage.removeItem('')
    // }
  }

  renderSuspenseFallback() {
    return (
      <Fragment>
        <Loading />
      </Fragment>
    );
  }

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return this.renderSuspenseFallback();
    }

    return (
      <Suspense fallback={this.renderSuspenseFallback()}>
        <UserContext.Provider value={this.contextProps}>
          <div id="dropdown-content">
            <Switch>
              <PrivateRoute exact path="/" component={pages.HomePage} />
              <PrivateRoute path="/perfil" component={pages.PerfilUsuario} />
              <PrivateRoute
                path="/devolutiva"
                component={pages.DevolutivaPage}
              />
              <PrivateRoute
                path="/assistente-pessoal-form/plan"
                component={GPTForm}
              />
              <PrivateRoute
                path="/assistente-pessoal-form/ind"
                component={GPTFormInd}
              />
              <PrivateRoute
                path="/assistente-pessoal-form/group"
                component={GPTFormGroup}
              />
              <PrivateRoute
                path="/assistente-pessoal-form/indplan"
                component={GPTFormIndPlan}
              />
              <PrivateRoute
                path="/portal-educat"
                component={PortalEducat}
              />
              <PrivateRoute
                path="/educhat"
                component={OpenWebUi}
              />
              <PrivateRoute
                path="/assistente-pessoal-form/inter"
                component={GPTFormInter}
              />
              <PrivateRoute
                path="/assistente-pessoal-retorno/:id"
                component={GPTResponse}
              />
              <PrivateRoute
                path="/assistente-pessoal-retorno-v0/:id"
                component={GPTResponseOld}
              />

              <Route
                path="/matrizes-referencia"
                render={() => <MatrizesReferencia />}
              />
              <Route
                path="/(itens|revisoes|encomendas|preview)"
                render={() => <Itens />}
              />
              <Route path="/analise" render={() => <Analise />} />
              <Route path="/(pre-testes|testes)" render={() => <Testes />} />
              <Route
                path="/(instrumentos-cognitivos|aplicacoes)"
                render={() => <Avaliacoes />}
              />
              <Route
                path="/instrumentos-cognitivosv2"
                render={() => <Atividades />}
              />
              <Route
                path="/(exames|competencias|habilidades|eixos)"
                render={() => <Cruds />}
              />
              <Route path="/usuarios" render={() => <Usuarios />} />
              <Route path="/recursos" render={() => <Recursos />} />
              <Route
                path="/filter-(aluno|turmas|nivel-habilidade|dres|dr|presenca|etapa-escolar|distribuicao-proficiencia-aluno|aluno-disciplina|relatorio-individual-aluno|relatorio-individual-turma|relatorio-individual-dr|relatorio-individual-dn|relatorio-individual-escola)"
                render={() => <Relatorios />}
              />
              <Route
                path="/relatorio-(aluno|nivel-habilidade|dres|dr|da-turma|etapa-escolar|distribuicao-proficiencia-aluno|meu|aluno-acertos|presenca|presenca-dr|aluno-geral|turma-geral|socioeconomico|comparativo-turmas|aluno-habilidade)"
                render={() => <Relatorios />}
              />
              <Route
                path="/diagnostico-(intervencao|intervencao-aluno)"
                render={() => <Relatorios />}
              />
              <Route path="/redacao" render={() => <Redacoes />} />
              <Route path="/report-plan" render={() => <Relatorios />} />
              <Route path="/report-plan-school" render={() => <Relatorios />} />
              <Route path="/report-plan-regional" render={() => <Relatorios />} />
              <Route
                path="/report-plan-periodo"
                render={() => <Relatorios />}
              />
              <Route
                path="/personal-(assistente|create|edit|list|view|data|home|report)"
                render={() => <PAE />}
              />
              {/* <Route path="/personal-(assistente|book)" render={() => <PAE />} /> */}
              <PrivateRoute
                path="/external-application-middleware"
                navbar={false}
                component={pages.ExternalApplicationMiddlewarePage}
              />
              <PrivateRoute path="/faq" component={() => <FAQ />} />
              <BookUploadProvider>
                <PrivateRoute path="/livros" component={ChapterUpload} />
              </BookUploadProvider>
            </Switch>
          </div>
        </UserContext.Provider>
      </Suspense>
    );
  }
}

export default withTracker(withRouter(MainSection));
